import React, {useState, useEffect} from 'react'
import { Container, NavDropdown, Navbar, Offcanvas, Nav, } from 'react-bootstrap'
import { useParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import logo from '../../assests/LOGO.png'
import 'bootstrap/dist/css/bootstrap.min.css';
import './header.css'

function Header() {
  const { id } = useParams();
  const { t,i18n } = useTranslation();
  const [scrolling, setScrolling] = useState(false);
  const changeLanguage = (lng) => {
    i18n.changeLanguage(lng);
  };
  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 0) {
        setScrolling(true);
      } else {
        setScrolling(false);
      }
    };

    window.addEventListener('scroll', handleScroll);

    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  return (
    <header className={scrolling ? 'scrollingbg' : ''}>
        {['lg'].map((expand) => (
        <Navbar key={expand} expand={expand}>
          <Container>
            <Navbar.Brand href="/">
              <img src={logo} width={50}/>
            </Navbar.Brand>
            <Navbar.Toggle aria-controls={`offcanvasNavbar-expand-${expand}`} />
            <Navbar.Offcanvas
              id={`offcanvasNavbar-expand-${expand}`}
              aria-labelledby={`offcanvasNavbarLabel-expand-${expand}`}
              placement="end"
            >
              <Offcanvas.Header closeButton>
                <Offcanvas.Title id={`offcanvasNavbarLabel-expand-${expand}`}>
                  Menu
                </Offcanvas.Title>
              </Offcanvas.Header>
              <Offcanvas.Body>
                <Nav variant="" defaultActiveKey="/" className="justify-content-end flex-grow-1 pe-3 d-flex">
                  <Nav.Link href="/" className={`d-flex me-1 align-items-center`}>
                            {t('home')}
                  </Nav.Link>
                  <NavDropdown
                    className="text"
                    title={t('workwear')}
                    id={`offcanvasNavbarDropdown-expand-${expand}`}
                  >
                    <NavDropdown.Item href="/product/coverall">
                        {t('bodyprotection')}
                    </NavDropdown.Item>
                    <NavDropdown.Item href="/product/masks">
                        {t('breathprotection')}
                    </NavDropdown.Item>
                    <NavDropdown.Item href="/product/eyewear">
                        {t('eyeprotection')}
                    </NavDropdown.Item>
                    <NavDropdown.Item href="/product/boots">
                        {t('footprotection')}
                    </NavDropdown.Item>
                    <NavDropdown.Item href="/product/hats">
                        {t('headprotection')}
                    </NavDropdown.Item>
                    <NavDropdown.Item href="/product/gloves">
                        {t('handprotection')}
                    </NavDropdown.Item>
                    <NavDropdown.Item href="/product/roadsafety">
                        {t('roadsafety')}
                    </NavDropdown.Item>
                  </NavDropdown>
                  <Nav.Link href="/about-us" className={`d-flex me-1 align-items-center`}>
                          {t('aboutus')}
                  </Nav.Link>
                  <Nav.Link href="/contact" className={`d-flex me-1 align-items-center`}>
                          {t('getintouch')}
                  </Nav.Link>
                  <Nav.Link className='d-flex'>
                        <button style={{border:"none", borderRight: '1px solid', background:"transparent"}} onClick={() => changeLanguage('en')}>EN</button>
                        <button style={{border:"none", background:"transparent", }} onClick={() => changeLanguage('ae')}>AE</button>
                  </Nav.Link>
                </Nav>
              </Offcanvas.Body>
            </Navbar.Offcanvas>
          </Container>
        </Navbar>
      ))}
    </header>
  )
}

export default Header